import { useParams } from 'react-router-dom';
import useInitialFetch from '../../services/api/useInitialFetch';
import { useAppDispatch } from '../../store/hooks';
import { update } from './cartSlice';
import CartDetails from './CartDetails';
import { toggleLoading } from '../App/appSlice';

function Cart() {
  const { cartId } = useParams();
  const dispatch = useAppDispatch();

  useInitialFetch(async (api) => {
    dispatch(toggleLoading(true));

    const cartResponse = await api.getCart(cartId);

    dispatch(update(cartResponse));
    dispatch(toggleLoading(false));
  });

  return <CartDetails />;
}

export default Cart;
